import socialAgentImg from '@/assets/images/theme-social-agent-v2.jpg';
import modernAgentImg from '@/assets/images/theme-modern-agent-v2.jpg';
import savvyAgentImg from '@/assets/images/theme-savvy-agent-v2.jpg';
import newsletterImg from '@/assets/images/newsletters.webp';
import videoScriptsImg from '@/assets/images/video-scripts.jpg';
import canvaReelImg from '@/assets/images/dfy-reels.png';
import stealReelImg from '@/assets/images/steal-the-reel.jpg';
import dailyStoriesImg from '@/assets/images/daily_instagram_stories.webp';
import monthlyCaptionsImg from '@/assets/images/monthly-captions.jpg';

export default {
    currentMonth: [
      {
        title: "Social Posts",
        subtitle: "January '25",
        platform: '',
        category: 'Posts',
        thumbnail: socialAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGU41sDQ10/h0Y0s-BFTDM8uhH8CB8SeQ/view?utm_content=DAGU41sDQ10&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 1
      },
      {
        title: "Social Posts",
        subtitle: "January '25",
        platform: '',
        category: 'Posts',
        thumbnail: modernAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGV1vWbJDU/HToWzl_9N2oufubfIX3bgA/view?utm_content=DAGV1vWbJDU&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 2
      },
      {
        title: "Social Posts",
        subtitle: "January '25",
        platform: '',
        category: 'Posts',
        thumbnail: savvyAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGV1t6Jqpw/7UvHAMvxX2wvILZDjTQWKg/view?utm_content=DAGV1t6Jqpw&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 3
      },
      {
        title: "Social Posts",
        subtitle: "January '25",
        platform: '',
        category: 'Posts',
        thumbnail: socialAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGYGfU2y9o/90oNZUrbWTkp3CIzyUi6ig/view?utm_content=DAGYGfU2y9o&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 4
      },
      {
        title: "Social Posts",
        subtitle: "January '25",
        platform: '',
        category: 'Posts',
        thumbnail: modernAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGYGdAc8zY/pqlQUH3P2ItQi2iHM3CoQw/view?utm_content=DAGYGdAc8zY&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 5
      },
      {
        title: "Social Posts",
        subtitle: "January '25",
        platform: '',
        category: 'Posts',
        thumbnail: savvyAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGYGXemL2E/I0RYIk4rvJHHZ38XknpWUw/view?utm_content=DAGYGXemL2E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 6
      },
      {
        title: "Newsletter & Blog Content",
        subtitle: "January '25",
        platform: '',
        category: 'Newsletters',
        thumbnail: newsletterImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Video Scripts",
        subtitle: "January '25",
        platform: '',
        category: 'Scripts',
        thumbnail: videoScriptsImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Steal the Reel",
        subtitle: "January '25",
        platform: '',
        category: 'Reels',
        thumbnail: stealReelImg,
        icon: null,
        url: 'https://docs.google.com/spreadsheets/d/19MLmMEfRbS_07u-sr8PRITkVFa0hAB_HahindcTuvJE/edit?gid=0#gid=0',
        theme: null
      },
      {
        title: "Canva Video Reels",
        subtitle: "January '25",
        platform: '',
        category: 'DFY Reels',
        thumbnail: canvaReelImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Stories",
        subtitle: "January '25",
        platform: 'Instagram',
        category: 'Scripts',
        thumbnail: dailyStoriesImg,
        icon: null,
        url: 'https://docs.google.com/spreadsheets/d/1ZZl9ZhqRuQF80dO3pq5YX-fEPiDsJjYxsbBYhtRc3og/edit?usp=sharing',
        theme: null
      },
      {
        title: "Monthly Captions",
        subtitle: "January '25",
        platform: '',
        category: 'Captions',
        thumbnail: monthlyCaptionsImg,
        icon: null,
        url: 'https://docs.google.com/document/d/1Vy62RNJMB9MnBzfL2zxP4RtWP6Eznn-9BENB_A6s9yg/edit?tab=t.0',
        theme: null
      },
    ],
    previousMonth: [
      {
        title: "Social Posts",
        subtitle: "December '24",
        platform: '',
        category: 'Posts',
        thumbnail: socialAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGRzYel71A/cS0AmoO8qg_KBFunqQvELA/view?utm_content=DAGRzYel71A&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 1
      },
      {
        title: "Social Posts",
        subtitle: "December '24",
        platform: '',
        category: 'Posts',
        thumbnail: modernAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGS7RZ4vhM/7RaWpf4T6scvzJs7zW0qzg/view?utm_content=DAGS7RZ4vhM&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 2
      },
      {
        title: "Social Posts",
        subtitle: "December '24",
        platform: '',
        category: 'Posts',
        thumbnail: savvyAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGS7R093CU/K4xtImWFWc-J3mEXYiYaTw/view?utm_content=DAGS7R093CU&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 3
      },
      {
        title: "Social Posts",
        subtitle: "December '24",
        platform: '',
        category: 'Posts',
        thumbnail: socialAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGWSAFITzA/591IgS_230hmHtPuFFxmgw/view?utm_content=DAGWSAFITzA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 4
      },
      {
        title: "Social Posts",
        subtitle: "December '24",
        platform: '',
        category: 'Posts',
        thumbnail: modernAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGWSBbwNeQ/ACzTPTEG8KzqhAjBioHjfQ/view?utm_content=DAGWSBbwNeQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 5
      },
      {
        title: "Social Posts",
        subtitle: "December '24",
        platform: '',
        category: 'Posts',
        thumbnail: savvyAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGWSBu1pCE/tmL49WDITaLENRlc0eC0AA/view?utm_content=DAGWSBu1pCE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 6
      },
      {
        title: "Newsletter & Blog Content",
        subtitle: "December '24",
        platform: '',
        category: 'Newsletters',
        thumbnail: newsletterImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Video Scripts",
        subtitle: "December '24",
        platform: '',
        category: 'Scripts',
        thumbnail: videoScriptsImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Steal the Reel",
        subtitle: "December '24",
        platform: '',
        category: 'Reels',
        thumbnail: stealReelImg,
        icon: null,
        url: 'https://docs.google.com/spreadsheets/d/1yckTJyhIm5fLjGgNHvwP_NB2uWqv-bCWHA7lyopsHTc/edit?gid=0#gid=0',
        theme: null
      },
      {
        title: "Canva Video Reels",
        subtitle: "December '24",
        platform: '',
        category: 'DFY Reels',
        thumbnail: canvaReelImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Stories",
        subtitle: "December '24",
        platform: 'Instagram',
        category: 'Scripts',
        thumbnail: dailyStoriesImg,
        icon: null,
        url: 'https://docs.google.com/spreadsheets/d/1D6nT6iIET2pOnVEz57AFV3_WhutxXKBaVEaxFDdkeeE/edit?usp=sharing',
        theme: null
      },
      {
        title: "Monthly Captions",
        subtitle: "December '24",
        platform: '',
        category: 'Captions',
        thumbnail: monthlyCaptionsImg,
        icon: null,
        url: 'https://docs.google.com/document/d/1Vy62RNJMB9MnBzfL2zxP4RtWP6Eznn-9BENB_A6s9yg/edit?usp=sharing',
        theme: null
      },
    ],
    November: [
      {
        title: "Social Posts",
        subtitle: "November '24",
        platform: '',
        category: 'Posts',
        thumbnail: socialAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGPKsVLras/O3MZf1PX8m--yKJjjvvQug/view?utm_content=DAGPKsVLras&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 1
      },
      {
        title: "Social Posts",
        subtitle: "November '24",
        platform: '',
        category: 'Posts',
        thumbnail: modernAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGPuVjVZ2g/pk19SkRotnbzLIdv2q2dhw/view?utm_content=DAGPuVjVZ2g&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 2
      },
      {
        title: "Social Posts",
        subtitle: "November '24",
        platform: '',
        category: 'Posts',
        thumbnail: savvyAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGPuVcCJP0/OqMO4h2z2o3_5Vo9XQ8D6Q/view?utm_content=DAGPuVcCJP0&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 3
      },
      {
        title: "Social Posts",
        subtitle: "November '24",
        platform: '',
        category: 'Posts',
        thumbnail: socialAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGRyW6uPv8/caMG2cHBv9hHfUsNZ5RWmA/view?utm_content=DAGRyW6uPv8&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 4
      },
      {
        title: "Social Posts",
        subtitle: "November '24",
        platform: '',
        category: 'Posts',
        thumbnail: modernAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGRyfnYgUw/sRoMTBVWPTut98rDrc3TvA/view?utm_content=DAGRyfnYgUw&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 5
      },
      {
        title: "Social Posts",
        subtitle: "November '24",
        platform: '',
        category: 'Posts',
        thumbnail: savvyAgentImg,
        icon: null,
        url: 'https://www.canva.com/design/DAGPKD1ak1E/Cls3ciSC8Z3CVWBQ4lclUg/view?utm_content=DAGPKD1ak1E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
        theme: 6
      },
      {
        title: "Newsletter & Blog Content",
        subtitle: "November '24",
        platform: '',
        category: 'Newsletters',
        thumbnail: newsletterImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Video Scripts",
        subtitle: "November '24",
        platform: '',
        category: 'Scripts',
        thumbnail: videoScriptsImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Steal the Reel",
        subtitle: "November '24",
        platform: '',
        category: 'Reels',
        thumbnail: stealReelImg,
        icon: null,
        url: 'https://docs.google.com/spreadsheets/d/1X9Paauh_yNmIMui4EB5M_0dgtohZqb8BZImu4Lyb0rI/edit?usp=sharing',
        theme: null
      },
      {
        title: "Canva Video Reels",
        subtitle: "November '24",
        platform: '',
        category: 'DFY Reels',
        thumbnail: canvaReelImg,
        icon: null,
        url: null,
        theme: null
      },
      {
        title: "Stories",
        subtitle: "November '24",
        platform: 'Instagram',
        category: 'Scripts',
        thumbnail: dailyStoriesImg,
        icon: null,
        url: 'https://docs.google.com/spreadsheets/d/1c42a5TvRqStRel_sV_2y9Va5vIP0N5ANgIg_jjDSBvQ/edit?usp=sharing',
        theme: null
      },
      {
        title: "Monthly Captions",
        subtitle: "November '24",
        platform: '',
        category: 'Captions',
        thumbnail: monthlyCaptionsImg,
        icon: null,
        url: 'https://docs.google.com/document/d/15YBtcBy8P_znypAI9Bg7MJpC4IO-3klHcJGtNnpocZY/edit?usp=sharing',
        theme: null
      },
    ],
    October: [
        {
            title: "Social Posts",
            subtitle: "October '24",
            platform: '',
            category: 'Posts',
            thumbnail: socialAgentImg,
            icon: null,
            url: 'https://www.canva.com/design/DAGMFzskIWM/8wXYwwhYordGxqR2MTy0UQ/view?utm_content=DAGMFzskIWM&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
            theme: 1
          },
          {
            title: "Social Posts",
            subtitle: "October '24",
            platform: '',
            category: 'Posts',
            thumbnail: modernAgentImg,
            icon: null,
            url: 'https://www.canva.com/design/DAGNGwIBVu4/pNEV8Q4K4cF4yPHtIqxjJQ/view?utm_content=DAGNGwIBVu4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
            theme: 2
          },
          {
            title: "Social Posts",
            subtitle: "October '24",
            platform: '',
            category: 'Posts',
            thumbnail: savvyAgentImg,
            icon: null,
            url: 'https://www.canva.com/design/DAGNG4W7D_E/cdr89k4g2rIK8S_S2l3ewg/view?utm_content=DAGNG4W7D_E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
            theme: 3
          },
          {
            title: "Social Posts",
            subtitle: "October '24",
            platform: '',
            category: 'Posts',
            thumbnail: socialAgentImg,
            icon: null,
            url: 'https://www.canva.com/design/DAGPKAXVpr0/fL1svVZ2LMu4VKVfiKQEaA/view?utm_content=DAGPKAXVpr0&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
            theme: 4
          },
          {
            title: "Social Posts",
            subtitle: "October '24",
            platform: '',
            category: 'Posts',
            thumbnail: modernAgentImg,
            icon: null,
            url: 'https://www.canva.com/design/DAGPKH2ATJ8/i7GgNW5DgC7C3yNdouM9fw/view?utm_content=DAGPKH2ATJ8&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
            theme: 5
          },
          {
            title: "Social Posts",
            subtitle: "October '24",
            platform: '',
            category: 'Posts',
            thumbnail: savvyAgentImg,
            icon: null,
            url: 'https://www.canva.com/design/DAGPKD1ak1E/Cls3ciSC8Z3CVWBQ4lclUg/view?utm_content=DAGPKD1ak1E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
            theme: 6
          },
          /*Completed*/
          {
            title: "Newsletter & Blog Content",
            subtitle: "October '24",
            platform: '',
            category: 'Newsletters',
            thumbnail: newsletterImg,
            icon: null,
            url: null,
            theme: null
          },
          {
            title: "Video Scripts",
            subtitle: "October '24",
            platform: '',
            category: 'Scripts',
            thumbnail: videoScriptsImg,
            icon: null,
            url: null,
            theme: null
          },
          {
            title: "Steal the Reel",
            subtitle: "October '24",
            platform: '',
            category: 'Reels',
            thumbnail: stealReelImg,
            icon: null,
            url: 'https://docs.google.com/spreadsheets/d/1hGAld8j7QqnebTuOMzpxTLf0T5UXEjCS0FHrzHUPFj8/edit?usp=sharing',
            theme: null
          },
          {
            title: "Canva Video Reels",
            subtitle: "October '24",
            platform: '',
            category: 'DFY Reels',
            thumbnail: canvaReelImg,
            icon: null,
            url: null,
            theme: null
          },
          {
            title: "Stories",
            subtitle: "October '24",
            platform: 'Instagram',
            category: 'Scripts',
            thumbnail: dailyStoriesImg,
            icon: null,
            url: 'https://docs.google.com/spreadsheets/d/1t6e1pCYXPMOK_JNYfzScgVxaJE8fNls5mFxyDZcGG50/edit?usp=sharing',
            theme: null
          },
          {
            title: "Monthly Captions",
            subtitle: "October '24",
            platform: '',
            category: 'Captions',
            thumbnail: monthlyCaptionsImg,
            icon: null,
            url: 'https://docs.google.com/document/d/1dWYJeGbHz9G3VzoJdDiXCuVsPQGZKCa9xPgmSwq66zE/edit?usp=sharing',
            theme: null
          },
    ],
    nextMonth: [
      
    ]
  };
  